import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const { color, radius } = theme;

const wrap: CSSObject = {
  position: 'relative',
  minWidth: '100%',
  boxSizing: 'border-box',
  borderCollapse: 'separate',
  borderSpacing: 0,
  'th, td': {
    padding: '14px 12px',
    borderBottom: `1px solid ${color.grey75}`,
    textAlign: 'center',
    verticalAlign: 'middle',
    fontSize: '14px',
    lineHeight: 1.45,
    color: color.text,
    whiteSpace: 'nowrap',

    '&:has(input, select)  *': {
      margin: 0,
    },

    'input:not([type=checkbox]),select': {
      height: 36,
    },
  },
  th: {
    background: color.grey50,
  },
  'tbody > tr': {
    transition: 'background-color 0.12s ease',
  },
  'tbody > tr:last-of-type > td': {
    borderBottom: 'none',
  },
  [mobile]: {
    'th, td': {
      padding: '12px 10px',
      fontSize: 13,
    },
  },
};

const head: CSSObject = {
  background: color.grey50,
  '> tr > td, > tr > th': {
    padding: '12px',
    fontSize: 13,
    fontWeight: 500,
    color: color.grey500,
    background: color.grey50,
    borderBottom: 'none',
  },
  '> tr > td:first-of-type, > tr > th:first-of-type': {
    borderRadius: `${radius.md}px 0 0 ${radius.md}px`,
  },
  '> tr > td:last-of-type, > tr > th:last-of-type': {
    borderRadius: `0 ${radius.md}px ${radius.md}px 0`,
  },
};

const stickyHead: CSSObject = {
  position: 'sticky',
  top: 0,
  zIndex: 1,
};

const stickyBottom: CSSObject = {
  position: 'sticky',
  bottom: 0,
  zIndex: 1,
  background: color.white,
  boxShadow: `inset 0 1px 0 ${color.grey100}`,
};

const hover: CSSObject = {
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: color.grey50,
  },
};

const selected: CSSObject = {
  backgroundColor: `${color.grey75} !important`,
};

const empty: CSSObject = {
  padding: '56px 12px !important',
  fontSize: '14px !important',
  color: `${color.textMuted} !important`,
};

const ellipsisCell: CSSObject = {
  display: '-webkit-box',
  wordWrap: 'break-word',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  lineHeight: '1.31',
};

export {
  wrap,
  head,
  stickyHead,
  hover,
  selected,
  stickyBottom,
  empty,
  ellipsisCell,
};
